<template>
        <section class="app">
            <header class="app-header">
                <Navbar v-if="settings" :facebook="settings.facebook"></Navbar>
            </header>
            <transition name="fade">
                <router-view :key="$route.params.id"></router-view>
            </transition>   
            <AppFooter v-if="settings" :facebook="settings.facebook">
                <p slot="left" class="app-footer__copy">&copy; 2017 - Moeto-Zdrave.com - Всички права запазени.</p>
                <p slot="right" class="app-footer__dev">Изработка на сайт от <a target="_blank" class="grindwebstudio" href="https://grindwebstudio.com/">Grind Web Studio</a></p>
            </AppFooter>
        </section>
</template>

<script>
import Navbar from './shared/Navbar'
import AppFooter from './shared/Footer'

import WindowService from './services/window'
// import Product from '@/services/product'

export default {
    name: 'app',
    components: { Navbar, AppFooter },
    data: function () {
        return {
            settings: this.$root.$data.settings
        }
    },
    methods: {
        windowOnScroll (header) {
            WindowService.addEvent('scroll', this.stickyHeader.bind(null, header))
        },
        stickyHeader (header) {
            if (WindowService.scrollTop() >= 15) {
                WindowService.addClassToElement(header, 'app-header--sticky')
            } else {
                WindowService.removeClassFromElement(header, 'app-header--sticky')
            }
        }
    },
    mounted: function () {
        const header = document.querySelector('.app-header')
        this.windowOnScroll(header)
    },
    beforeDestroy: function () {
        WindowService.removeEvent('scroll', this.stickyHeader)
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue?06e6280f